"use client";

import { Forms } from "@/components/auth/Forms";
import { Dialog, DialogContent, DialogDescription, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { useRouter } from "@/i18n/routing";
import { DEFAULT_LOGIN_URL } from "@/routes";

interface ILoginButtonProps {
    children: React.ReactNode;
    mode?: "redirect" | "modal";
}

export const LoginButton = ({ children, mode = "redirect" }: ILoginButtonProps) => {
    const router = useRouter();

    const onClick = () => {
        router.push(DEFAULT_LOGIN_URL);
    };

    if (mode === "modal") {
        return (
            <Dialog>
                <DialogTrigger asChild>
                    <span className="cursor-pointer">
                        {children}
                    </span>
                </DialogTrigger>
                <DialogContent className="p-0">
                    <DialogTitle className="hidden"></DialogTitle>
                    <DialogDescription className="hidden"></DialogDescription>
                    <Forms inModal />
                </DialogContent>
            </Dialog>
        );
    }

    return (
        <span onClick={ onClick } className="cursor-pointer">
            {children}
        </span>
    );
};